module.exports = __webpack_public_path__ + "img/4.ab4fa654.jpg";